import usePersonalInformation from 'hooks/requests/kyc/usePersonalInformation';
import { getPersonalInformationData } from 'pages/profile/components/ProfileTabContent/Account/PersonalInformation/utils';
import ProfileEditableTable from 'pages/profile/components/ProfileTabContent/components/ProfileEditableTable';
import ProfileSection from 'pages/profile/components/ProfileTabContent/components/ProfileSection';
import classes from './index.module.scss';
import Button from 'components/generics/buttons/Button';
import useAuth from 'context/Auth';
import useResponsive from 'hooks/logics/useResponsive';

const PersonalInformation = () => {
  const { personalInformation } = usePersonalInformation();
  const { logout } = useAuth();
  const { isMobile } = useResponsive();

  return (
    <ProfileSection
      title={'Personal Information'}
      titlesClassName={classes.title}
    >
      <ProfileEditableTable
        data={getPersonalInformationData(personalInformation)}
      />
      {isMobile && (
        <Button
          onClick={logout}
          className={classes.button}
        >
          Log Out
        </Button>
      )}
    </ProfileSection>
  );
};

export default PersonalInformation;
